import React from "react";
import {ChipLabel} from "./index";

const ActiveChip = ({active, positive="Yes", negative="No", hoverable=false}) => {
    return (
        <React.Fragment>
            <ChipLabel
                label={active ? positive : negative}
                className={`data-access-chip ${active ? 'success' : 'error'} ${hoverable ? 'hoverable' : null}`}
            />
        </React.Fragment>
    )
}

export default ActiveChip;